module.exports = __webpack_public_path__ + "img/umbilical_system.ccb55654.png";